(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name thismomentGlowModuleClcApprovalForm
     * @module thismoment.glow.component.module.clc-approval-form
     *
     * @description
     *
     */

  require('./scss/module-clc-approval-form.scss')

  var MODULE_NAME = 'thismoment.glow.component.module.clc-approval-form'
  var templateUrl = require('./tpl/module-clc-approval-form.html')

  angular
    .module(MODULE_NAME, [
      require('./provider/clc-api'),
      require('../../../../card')
    ])
    .component('thismomentGlowModuleClcApprovalForm', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        source: '<',
        margin: '<',
        formItems: '<',
        approveButtonColor: '<',
        approveButtonText: '<',
        approveButtonTextColor: '<',
        denyButtonColor: '<',
        denyButtonText: '<',
        denyButtonTextColor: '<',
        signinButtonColor: '<',
        signinButtonText: '<',
        signinButtonTextColor: '<',
        thankYouMessage: '<'
      },
      controller: glowClcApprovalController
    })

  glowClcApprovalController.$inject = ['$window', '$anchorScroll', '$stateParams', 'SdkConfig', 'ClcApi', 'analyticsSDK']
  function glowClcApprovalController ($window, $anchorScroll, $stateParams, SdkConfig, ClcApi, analyticsSDK) {
    var vm = this

    vm.$onInit = clcApprovalInit

    function clcApprovalInit () {
      vm.onSignin = onSignin

      // analytics
      vm.trackEvent = analyticsSDK.setupEventTracking({
        'module title': vm.name,
        'module type': 'clc_approval_form',
        'tm module id': vm.moduleId
      })

      // formly
      vm.formData = {}
      vm.fields = vm.formItems
      vm.onSubmit = onApprove
      vm.onCancel = onDeny
      vm.submitBackgroundColor = vm.approveButtonColor
      vm.submitColor = vm.approveButtonTextColor
      vm.submitText = vm.approveButtonText
      vm.cancelBackgroundColor = vm.denyButtonColor
      vm.cancelColor = vm.denyButtonTextColor
      vm.cancelText = vm.denyButtonText

      vm.styles = {
        wrapper: {
          'margin-top': vm.margin.split(' ')[0],
          'margin-bottom': vm.margin.split(' ')[2]
        },
        signin: {
          'background-color': vm.signinButtonColor,
          'color': vm.signinButtonTextColor
        }
      }

      vm.busy = false
      vm.authenticated = false
      vm.noContent = false

      if ($stateParams.linkedAccount) {
        vm.busy = true
        var linkedAccount = JSON.parse($stateParams.linkedAccount)
        if ('error' in linkedAccount) {
          vm.noContent = true
          vm.busy = false
        } else {
          ClcApi.getClcContent({
            'token': linkedAccount.token,
            'token_secret': linkedAccount.token_secret,
            'user_id': linkedAccount.native_id,
            'request_id': SdkConfig.get('solution_hash')
          }, (result) => {
            vm.cardAnalytics = {
              'display playlist': 'Clc Approval',
              'display playlist id': 'Clc Request ' + SdkConfig.get('solution_hash')
            }
            vm.cardOptions = {}
            if (!result.data.content) {
              vm.noContent = true
              vm.linkedUsername = linkedAccount.username
            } else {
              vm.requestUuid = result.data.id
              vm.item = result.data.content
              vm.authenticated = true
            }
            vm.busy = false
          })
        }
      }

      function onSignin () {
        let service = vm.source.replace('-user', '')
        $window.location = '//oauth.' + SdkConfig.get('env_host') + '/authorize?service=' + service + '&type=linked&tm-redirect-method=sametab&tm-redirect-url=' + $window.location.href
      }

      function onApprove () {
        patchClc('1')
      }

      function onDeny () {
        patchClc('-1')
      }

      function patchClc (status) {
        var eventName = (status === '1') ? 'CLC Approved' : 'CLC Denied'
        var analyticsProps = {
          'event trigger': 'clc request',
          'request id': SdkConfig.get('solution_hash')
        }

        for (var key in vm.formData) {
          analyticsProps['form data ' + key] = vm.formData[key]
        }
        vm.trackEvent(eventName, analyticsProps)

        ClcApi.updateClcRequest(vm.requestUuid, {
          'status': status,
          'response_date': Math.floor(Date.now() / 1000),
          'user_form_response': vm.formData
        })
        vm.done = true
        $anchorScroll()
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-clc-approval-form/index.js